import { IntlShape } from "react-intl";

export const VerificationName = "Verification";
export const AccountName = "Account";
export const InfoName = "Information | manuals";
export const DepositName = "Insurance deposit";
export const OthersName = "Other product | service";
export const DesignName = 'Design';
export const DevelopmentName = 'Development | programming';
export const DocumentsName = 'Documents';
export const GamingName = 'Gaming accounts | gaming items';
export const CurrencyName = 'Currency exchange';
export const CollateralName = 'Collateral';

export const getCategoryName = (
  intl: IntlShape,
  name: string | undefined
): string => {
  const VERIFICATION = intl.formatMessage({ id: "DEAL_CARD_VERIFICATION" });
  const ACCOUNT = intl.formatMessage({ id: "DEAL_CARD_ACCOUNT" });
  const INFO = intl.formatMessage({ id: "DEAL_CARD_INFO" });
  const DEPOSIT = intl.formatMessage({ id: "DEAL_CARD_DEPOSIT" });
  const OTHERS = intl.formatMessage({ id: "DEAL_CARD_OTHERS" });
  const DESIGN = intl.formatMessage({ id: 'DEAL_CARD_DESIGN' });
	const DEVELOPMENT = intl.formatMessage({ id: 'DEAL_CARD_DEVELOPMENT' });
	const DOCUMENTS = intl.formatMessage({ id: 'DEAL_CARD_DOCUMENTS' });
	const GAMING = intl.formatMessage({ id: 'DEAL_CARD_GAMING' });
	const CURRENCY = intl.formatMessage({ id: 'DEAL_CARD_CURRENCY' });
	const COLLATERAL = intl.formatMessage({ id: 'DEAL_CARD_COLLATERAL' });

  switch (name) {
    case VerificationName:
      return VERIFICATION;
    case AccountName:
      return ACCOUNT;
    case InfoName:
      return INFO;
    case DepositName:
      return DEPOSIT;
    case OthersName:
      return OTHERS;
    case DesignName:
      return DESIGN;
    case DevelopmentName:
      return DEVELOPMENT;
    case DocumentsName:
      return DOCUMENTS;
    case GamingName:
      return GAMING;
    case CurrencyName:
      return CURRENCY;
    case CollateralName:
      return COLLATERAL;
    default:
      return name || 'Category';
  }
};
